import React from "react";

export default function ButtonDark({ 
  onClick,
  disabled = false,
  children, 
  className = "" 
}: { 
  onClick: () => void,
  disabled?: boolean,
  children: React.ReactNode,
  className?: string 
}) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`inline-flex hover:border-transparent border-2 border-transparent items-center text-white bg-[#c35847] hover:bg-[#b85b50] justify-center gap-2.5 rounded-md px-5 py-2 text-sm font-normal leading-[1.4] text-white no-underline shadow-[rgba(0,0,0,0.2)_0px_4px_6px_2px] transition-all ${className}`}
    >
      {children}
    </button>
  );
}
